module.exports = __webpack_public_path__ + "static/img/banner_3.49a30f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner_3.png
// module id = qJic
// module chunks = 94